module.exports = __webpack_public_path__ + "img/shimao.8bf9dae2.png";